// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__e9ILn"};